export default "__VITE_PUBLIC_ASSET__fca10caf__"